import LP from '../0-lp';
import $ from 'jquery';
import {pubsub} from '../../../Core/PubSub';

LP.pollTextsPage = {
  isProcessing: false,
  readyColor: '#F0F0F0',
  // editColor    : '#FFF0D0',
  editColor: '#FFFFFF',
  changedColor: '#FFFFFF',
  loadingColor: '#FFFFFF',

  init: function () {
    $('#lp-form-texts').timedLoader(false);
    LP.pollTextsPage.isProcessing = false;

    LP.dlgLanguages.prepare('a[dialog="languages"]', {
      afterSubmit: function (json) {
        LP.pollTextsPage.onChangeLang(json.lang);
        pubsub.publish('languagesChanged', json);
        return true;
      },
    });

    $('.lp-print-button').click(function () {
      var url = $(this).attr('url');
      var params = $(this).attr('url_params');
      var target = $(this).attr('target');
      params += '&sourceLang=' + $('select[control="srcLang"]').val();
      params += '&targetLang=' + $('select[control="trgtLang"]').val();

      window.Browser.redirectPost(url, params, target);
      return false;
    });

    $('[data-poll-id][data-texts-type]').each(function () {
      window.reactPortals.addPollTranslationsMenu(this);
    });

    LP.pollTextsPage.initPageContent();
  },

  initPageContent: function () {
    LP.pollTextsPage.isProcessing = false;
    $('[action="openSection"]').click(LP.pollTextsPage.openSection);

    $('select[control="srcLang"]').change(function () {
      LP.pollTextsPage.onChangeLang();
    });
    $('select[control="trgtLang"]').change(function () {
      LP.pollTextsPage.onChangeLang();
    });

    LP.pollTextsPage.initSection();
  },

  initSection: function (root) {
    $('.lp-subsection-header', root).click(LP.pollTextsPage.openSubsection);

    $('.lp-translate-copy', root).click(LP.pollTextsPage.copyText);

    $('a[dialog="texteditor"]', root).click(function () {
      LP.pollTextsPage.openEditor($(this), 'input');
    });
    $('a[dialog="textareaeditor"]', root).click(function () {
      LP.pollTextsPage.openEditor($(this), 'textarea');
    });

    $('textarea', root).focus(function () {
      LP.pollTextsPage.onFocus($(this));
    });
    $('textarea', root).keyup(function () {
      LP.pollTextsPage.onKeypress($(this));
    });
    $('textarea', root).blur(function () {
      LP.pollTextsPage.onBlur($(this));
    });
    $('input[type="text"]', root).focus(function () {
      LP.pollTextsPage.onFocus($(this));
    });
    $('input[type="text"]', root).keyup(function () {
      LP.pollTextsPage.onKeypress($(this));
    });
    $('input[type="text"]', root).blur(function () {
      LP.pollTextsPage.onBlur($(this));
    });
  },

  openSection: function () {
    var header = $(this);
    var isOpen = header.hasClass('icon-down-open-1');

    var section = header.parent();
    var content = $('.lp-section-content', section);

    if (isOpen) {
      content.slideUp(200, function () {
        header.removeClass('icon-down-open-1').addClass('icon-right-open-1');
      });
      window.Browser.send(header.attr('close_url'), header.attr('url_params'));
    } else {
      if (content.html().length == 0) {
        content.timedLoader(1);
        window.Browser.loadHTML(content, header.attr('open_url'), header.attr('url_params'), function () {
          content.timedLoader(false);
          LP.pollTextsPage.initSection(content);
        });
      }

      header.removeClass('icon-right-open-1').addClass('icon-down-open-1');
      content.slideDown(200, function () {});
    }
  },

  openSubsection: function () {
    var header = $(this);
    var section = header.parent();
    var isOpen = header.hasClass('icon-down-open-1');
    var content = $('.lp-subsection-content', section);

    if (isOpen) {
      content.hide();
      header.removeClass('icon-down-open-1').addClass('icon-right-open-1');
      window.Browser.send(header.attr('close_url'), header.attr('url_params'));
    } else {
      content.show();
      header.removeClass('icon-right-open-1').addClass('icon-down-open-1');
      window.Browser.send(header.attr('open_url'), header.attr('url_params'));
    }
  },

  onChangeLang: function (defaultLang) {
    if (LP.pollTextsPage.isProcessing) {
      return;
    }
    LP.pollTextsPage.isProcessing = true;

    var sourceLang = $('select[control="srcLang"]').val();
    var targetLang = $('select[control="trgtLang"]').val();

    if (defaultLang != null) {
      targetLang = defaultLang;
    }

    var formtexts = $('#lp-form-texts');
    formtexts.timedLoader(1).find('.lp-loader-content').addClass('lp-lang-loader-image');
    window.Browser.loadHTML(formtexts, 'backend/getPollTexts', 'poll=' + $('#pollId').val() + '&sourceLang=' + sourceLang + '&targetLang=' + targetLang, LP.pollTextsPage.initPageContent);
  },

  onFocus: function (input) {
    input.attr('prev', input.val());
    input.css('background-color', LP.pollTextsPage.editColor);
  },

  onKeypress: function (input) {
    if (input.val() != input.attr('prev')) {
      input.css('background-color', LP.pollTextsPage.changedColor);
    } else {
      input.css('background-color', LP.pollTextsPage.editColor);
    }
  },

  onBlur: function (input) {
    var prev = input.attr('prev');
    var curr = input.val();

    if (curr != prev) {
      if (prev == '' && curr != '') {
        LP.pollTextsPage.updateCounter(input, +1);
      }
      if (prev != '' && curr == '') {
        LP.pollTextsPage.updateCounter(input, -1);
      }

      LP.pollTextsPage.saveText(input);
      LP.pollTextsPage.refreshOrginal(input);
    }
  },

  copyText: function () {
    var tr = $(this).parent().parent();
    var input = $('input,textarea', tr);
    var org = $('.lp-org-text', tr);

    if (input.val() == '' && org.html() != '') {
      LP.pollTextsPage.updateCounter(input, +1);
    }

    input.val(org.html());
    LP.pollTextsPage.saveText(input);
  },

  refreshOrginal: function (input) {
    var sourceLang = $('select[control="srcLang"]').val();
    var targetLang = $('select[control="trgtLang"]').val();
    if (sourceLang == targetLang) {
      var mode = $('a[task="getPollTextsTable"].ui-state-active').attr('mode');
      if (mode == 'items') {
        var row = $(input).parent().parent();
        var org = $('.lp-org-text', row);
        org.html(input.val());
      }
    }
  },

  updateCounter: function (input, value) {
    var section = input.closest('.lp-section');
    var subsection = input.closest('.lp-subsection');

    var globalCounter = $('.lp-global-counter');
    var sectionCounter = $('.lp-trs-counter', section);
    var subsectionCounter = $('.lp-trsub-counter', subsection);

    var counter = 0;
    if (globalCounter) {
      counter = parseInt(globalCounter.html());
      globalCounter.html(counter + value);
    }
    if (sectionCounter) {
      counter = parseInt(sectionCounter.html());
      sectionCounter.html(counter + value);
    }
    if (subsectionCounter) {
      counter = parseInt(subsectionCounter.html());
      subsectionCounter.html(counter + value);
    }
  },

  openEditor: function (anchor, inputType) {
    var text = '';
    var element = $(inputType, anchor.parent());
    if (inputType == 'input') {
      text = element.val();
    }
    if (inputType == 'textarea') {
      text = element.html();
    }

    if (text.length > 0) {
      text = encodeURIComponent(text);
    }

    var href = 'backend/openTextEditor/';
    var params = '&poll=' + $('#pollId').val() + '&text=' + text + '&mode=edit';

    LP.UI.openTextEditor(href, params, element, 'itemTextEditor', anchor.attr('title'), false, false, function () {
      LP.pollTextsPage.saveText(element);
    });
  },

  saveText: function (input) {
    if (input.attr('locked')) {
      return;
    }

    input.attr('locked', '1');
    // input.attr('disabled','1');
    input.css('background-color', LP.pollTextsPage.loadingColor);

    LP.pollTextsPage.isProcessing = true;

    var section = input.closest('.lp-section');
    var url = $('#lp-form-texts').attr('action');
    var targetLang = $('select[control="trgtLang"]').val();
    var cleanup = function () {
      $('.lp-text-loader', section).timedLoader(false);
      input.removeAttr('disabled').removeAttr('prev').removeAttr('locked');
      loadDiv.remove();
      LP.pollTextsPage.isProcessing = false;
    };

    var loadDiv = $('<div>').timedLoader({timeout: 1, size: 'small'});
    loadDiv.css('position', 'absolute');
    loadDiv.css('top', input.position().top + 1); //input has "border-top-width" 1px
    loadDiv.css('width', input.outerWidth()).css('height', input.outerHeight());
    loadDiv.insertAfter(input);

    $('.lp-text-loader', section).timedLoader(1);

    window.Browser.send(url, input.serialize() + '&targetLang=' + targetLang, cleanup, cleanup);
  },

  saveAllTexts: function () {
    if (LP.pollTextsPage.isProcessing) {
      return;
    }
    LP.pollTextsPage.isProcessing = true;

    var form = $('#lp-form-texts');
    var onSuccess = function () {
      LP.pollTextsPage.isProcessing = false;
    };
    var onFailed = function () {
      LP.pollTextsPage.isProcessing = false;
    };

    window.Browser.send(form.attr('action'), form.serialize(), onSuccess, onFailed);
  },

  saveLanguages: function () {
    if (LP.pollTextsPage.isProcessing) {
      return;
    }
    LP.pollTextsPage.isProcessing = true;

    var cb = function () {
      return (LP.pollTextsPage.isProcessing = false);
    };

    var form = $('#lp-form-texts');
    window.Browser.send(form.attr('action'), form.serialize(), cb, cb);
  },
};
